import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';

export const useIsComplementaryRecommendationEnabled = () => {
  return !!useIsSoftFeatureToggleActive('complementary_recommendation');
};
